import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Search } from 'lucide-react';
import Reveal from '../components/Reveal';
import { NEWS } from '../data/mock';

const CATS = ['All', ...Array.from(new Set(NEWS.map((n) => n.category)))];

export default function News() {
  const [cat, setCat] = useState('All');
  const [q, setQ] = useState('');
  const list = useMemo(() => {
    let l = cat === 'All' ? NEWS : NEWS.filter((n) => n.category === cat);
    if (q) l = l.filter((n) => (n.title + n.excerpt).toLowerCase().includes(q.toLowerCase()));
    return l;
  }, [cat, q]);

  return (
    <div className="bg-[var(--bg)]">
      <section className="pt-36 pb-16 border-b border-[var(--line)]">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> 006 — News</span>
          <Reveal>
            <h1 className="font-display text-7xl md:text-[150px] leading-[0.92] mt-6">Read all <span className="font-display-italic text-[var(--coral)]">about it.</span></h1>
          </Reveal>
          <div className="grid md:grid-cols-12 gap-8 mt-10">
            <p className="md:col-span-6 md:col-start-7 text-[18px] text-[var(--ink-mute)] leading-relaxed">
              Studio updates, project milestones, awards, and the occasional dispatch from the Shropshire mill.
            </p>
          </div>
        </div>
      </section>

      <section className="py-8 border-b border-[var(--line)] sticky top-20 lg:top-24 bg-[var(--bg)]/95 backdrop-blur z-30">
        <div className="container-rs flex flex-wrap items-center gap-3">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`px-5 py-2.5 rounded-full font-tag border transition-colors ${cat === c ? 'bg-[var(--navy)] text-white border-[var(--navy)]' : 'border-[var(--line)] hover:border-[var(--navy)]'}`}>{c}</button>
          ))}
          <div className="flex items-center gap-2 ml-auto px-4 py-2 rounded-full border border-[var(--line)] bg-white">
            <Search size={14} className="text-[var(--ink-mute)]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search news" className="bg-transparent outline-none text-sm w-44" />
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container-rs grid md:grid-cols-3 gap-10">
          {list.map((n, i) => (
            <Reveal key={n.id} delay={(i % 3) * 80} className="group">
              <div className="overflow-hidden rounded-2xl">
                <img src={n.image} alt={n.title} className="zoom-img w-full h-[300px] object-cover" />
              </div>
              <div className="mt-5 font-tag text-[var(--ink-mute)] flex items-center gap-3"><span className="coral-dot" />{n.category} · {new Date(n.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</div>
              <h3 className="font-display text-2xl md:text-3xl mt-3 group-hover:text-[var(--coral)] transition-colors">{n.title}</h3>
              <p className="mt-2 text-[14px] text-[var(--ink-mute)] leading-relaxed">{n.excerpt}</p>
              <Link to="/news" className="inline-flex items-center gap-2 mt-4 font-tag u-link">Read more <ArrowUpRight size={12} /></Link>
            </Reveal>
          ))}
          {list.length === 0 && <div className="md:col-span-3 py-24 text-center text-[var(--ink-mute)] font-tag">No articles found.</div>}
        </div>
      </section>
    </div>
  );
}
